import { RFTfeature } from "../components/features/RFTfeature";

export const convertToQty = (unitType = "", item, sold = "") => {
  let saleQty;
  let soldQty;
  let purchaseQty = 0;

  let companyCode = localStorage.getItem("companyCode");
  if (sold == "soldQty") {
    if (RFTfeature()) {
      if (unitType == "serviceRFT" || unitType == "RFT") {
        soldQty = parseFloat(item.sold_quantity / 328);
      } else {
        soldQty = parseInt(item.sold_quantity);
      }
    } else {
      soldQty = parseInt(item.sold_quantity);
    }
  } else if (sold == "purchaseQty") {
    if (RFTfeature()) {
      if (unitType == "serviceRFT" || unitType == "RFT") {
        purchaseQty = parseFloat(item.purchased_quantity / 328);
      } else {
        purchaseQty = parseInt(item.purchased_quantity);
      }
    } else {
      purchaseQty = parseInt(item.purchased_quantity);
    }
  } else {
    if (RFTfeature()) {
      if (unitType == "serviceRFT") {
        if (item.fivePercent) {
          let qty = parseFloat(item.saleQuantity / 328);
          saleQty = qty + parseFloat(item.fivePercent);
        }
      } else if (unitType == "RFT") {
        saleQty = parseFloat(item.saleQuantity / 328);
      } else {
        saleQty = parseInt(item.saleQuantity);
      }
    } else {
      saleQty = parseInt(item.saleQuantity);
    }
  }

  return { saleQty, soldQty, purchaseQty };
};
